import React, { useState } from "react";
import { Popover } from "antd";
import { removeOnClickBubble } from "utils";
import Elipsis from "assets/img/icons/Elipsis.svg";
import styled from "styled-components";
import { RootState } from "store";
import { useSelector } from "react-redux";

interface IListCardPopoverItem {
  text: string;
  image?: any;
  handler: any;
}

interface IListCardPopoverProps {
  popoverTitleItems: Array<IListCardPopoverItem>;
  popoverContentItems: Array<IListCardPopoverItem>;
  isTitleItemFunctional?: boolean;
}
const ListCardPopover: React.FC<IListCardPopoverProps> = ({
  popoverTitleItems,
  popoverContentItems,
  isTitleItemFunctional = false,
}) => {
  const [isListItemClicked, setIsListItemClicked] = useState(false);
  const exportLoading: boolean = useSelector((state: RootState) => state.audienceLists.exportLoading);
  const cloneLoading = useSelector((state: RootState) => state.audienceLists.cloneLoading);

  const popoverTitle = (
    <>
      {popoverTitleItems.map((titleItem: IListCardPopoverItem, index) => {
        return (
          <TitleItem
            key={index}
            className={`padding-top-sm padding-bottom-sm padding-right-md ${
              exportLoading === true || cloneLoading ? "disabled" : ""
            }`}
            {...(isTitleItemFunctional
              ? {
                  onClick: (e) => {
                    setIsListItemClicked(false);
                    removeOnClickBubble(e);
                    titleItem.handler(e);
                  },
                }
              : {})}
          >
            <h4 className="mb-0">
              {titleItem.text}
              {titleItem.text === "Clone List" && (
                <>
                  &nbsp;
                  <div hidden={!cloneLoading} className="spinner-border spinner-border-sm" role="status">
                    <span className="sr-only"></span>
                  </div>
                </>
              )}
            </h4>
          </TitleItem>
        );
      })}
    </>
  );
  const popoverContent = (
    <div className="BlogItemDropdown">
      <ul>
        {popoverContentItems.map((contentItem: IListCardPopoverItem, index) => {
          return (
            <li
              key={index}
              className="d-flex align-items-center"
              onClick={(e) => {
                setIsListItemClicked(false);
                removeOnClickBubble(e);
                contentItem.handler(e);
              }}
            >
              <MarginedImage src={contentItem.image} alt="" />
              <strong>{`${contentItem.text}`}</strong>
            </li>
          );
        })}
      </ul>
    </div>
  );
  return (
    <Popover
      title={popoverTitle}
      content={popoverContent}
      overlayClassName="BlogPopover Popover-share"
      placement="leftTop"
      trigger="click"
      visible={isListItemClicked}
      onVisibleChange={setIsListItemClicked}
      getPopupContainer={() => document.querySelectorAll(".content-inner")[0] as HTMLElement}
    >
      <a onClick={removeOnClickBubble} className="px-2 float-right">
        <img src={Elipsis} />
      </a>
    </Popover>
  );
};

export default ListCardPopover;

const TitleItem = styled.div`
  cursor: pointer;
`;
const MarginedImage = styled.img`
  margin-right: 0.5em;
`;
